import React, { ReactNode, useMemo } from 'react';
import { PaginatorProvider, PaginatorStore, SearchProvider, SearchStore } from '@warehouse/shared/ui';
import { CHILDREN_LIST_KEY, PersistQueryParamsConfig } from '@warehouse/shared/util';
import { ListRelationshipStoreProvider } from './list-relationship.store';

export function RelationshipListStoreConfig({ children }: { children: ReactNode }) {
	const searchStoreConfig = useMemo(
		(): PersistQueryParamsConfig<SearchStore> => ({
			searchValue: {
				defaultValue: '',
			},
		}),
		[],
	);

	const paginationStoreConfig = useMemo(
		(): PersistQueryParamsConfig<PaginatorStore> => ({
			page: {
				type: 'number',
				defaultValue: 1,
			},
			perPage: {
				type: 'number',
				defaultValue: 10,
				localStorageKey: CHILDREN_LIST_KEY,
			},
		}),
		[],
	);

	return (
		<SearchProvider config={searchStoreConfig}>
			<PaginatorProvider config={paginationStoreConfig}>
				<ListRelationshipStoreProvider>{children}</ListRelationshipStoreProvider>
			</PaginatorProvider>
		</SearchProvider>
	);
}
